import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography';
import { Line, Doughnut, Bar } from 'react-chartjs-2';
import Grid from '@material-ui/core/Grid';
import { CommonBadgeGenerate } from '../Components/commonBadge'

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },

    card: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        borderRadius: '10px',
        boxShadow: ' 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
        marginTop: 30,
    },

    titleSecondary: {
        fontSize: 15,
        alignContent: 'center'
    },

});


export const ChartCollectionCategoryByMonthGrid = ({ catData }) => {
    const classes = useStyles();
    const [collectionCategoryByMonthData, setCollectionCategoryByMonthData] = useState(catData);

    useEffect(() => {

        setCollectionCategoryByMonthData({
            collectionCategoryBarChartData: catData.collectionCategoryBarChartData,
            dougnutChartData: catData.dougnutChartData
        });


    }, [catData]);

    return (

        <Card className={classes.card} boxShadow={3}>

            <CardContent>
                <CommonBadgeGenerate
                    cardTitle={
                        <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                            <b>Collection Category By Month</b>
                        </Typography>
                    }
                    badgeName={"B"}
                />
                <br /><br /><br /><br />
                <Grid container>
                    <Grid item xs={6} >
                        <Doughnut

                            data={collectionCategoryByMonthData.dougnutChartData}
                            options={{
                                responsive: true,
                                maintainAspectRatio: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <Bar
                            data={collectionCategoryByMonthData.collectionCategoryBarChartData}
                            options={{
                                responsive: true,
                                scales: {
                                    xAxes: [{ stacked: true }],
                                    yAxes: [{ stacked: true }]
                                }
                            }}
                        />
                    </Grid>
                </Grid>
                <br /><br /><br /><br />

            </CardContent>

        </Card>

    );

}